import React from "react";

const CustomPagination = ({ rowsPerPage, rowCount, onChangePage, currentPage }) => {
    const totalPages = Math.ceil(rowCount / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) {
            onChangePage(newPage);
        }
    };

    return (
        <div className="custom-pagination">
            <button
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
                aria-disabled={currentPage === 1}
            >
                First
            </button>
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-disabled={currentPage === 1}
            >
                Prev
            </button>
            <span>
                Page {currentPage} of {totalPages}
            </span>
            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-disabled={currentPage === totalPages}
            >
                Next
            </button>
            <button
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
                aria-disabled={currentPage === totalPages}
            >
                Last
            </button>
        </div>
    );
};

export default CustomPagination;